import styled from 'styled-components';
import { Stack } from '@fluentui/react';

export const Container = styled(Stack)`
	background: #f4f7f9;
	height: 100%;
	padding: 50px 3%;
`;
